module.exports = "/images/Guillaume.jpg?e8257f592334b02b5fc6563658feee51";